import { useEffect } from 'react';
import { useMap } from 'react-leaflet';
import L from 'leaflet';

const MapProvinceLabels = () => {
  const map = useMap();
  
  useEffect(() => {
    const labelLayer = L.layerGroup().addTo(map);
    const provinceCoords = [
      { name: "Balochistan", lat: 28.423907, lng: 65.500632 },
      { name: "Sindh",       lat: 25.971789, lng: 68.662573 },
      { name: "Punjab",      lat: 30.876024, lng: 72.211690 },
      { name: "AJK",         lat: 33.887396, lng: 76.147984 },
      { name: "GB",          lat: 35.930828, lng: 74.728337 },
      { name: "KPK",         lat: 34.747789, lng: 72.147161 },
      { name: "Islamabad",   lat: 33.716666, lng: 73.133761 },
    ];
    
    provinceCoords.forEach(p => {
      const label = L.marker([p.lat, p.lng], {
        icon: L.divIcon({
          className: 'province-label',
          html: `<div class="settalite-label province">${p.name}</div>`,
          iconSize: [0, 0],
          iconAnchor: [0, 0],
        }),
        interactive: false,
        zIndexOffset: 1000,
      });
      label.addTo(labelLayer);
    });
    
    return () => map.removeLayer(labelLayer);
  }, [map]);
  
  return null;
};

export default MapProvinceLabels;